import { gql } from "@apollo/client"
import LinkButton from "components/Link/LinkButton"
import { BUTTON_TYPES, TRACK_EVENTS } from "constants/events"
import mixpanel from "mixpanel-browser"
import { ApplyButton_post } from "__generated__/ApplyButton_post"
import { ListingInfo_listing } from "__generated__/ListingInfo_listing"

const ApplyButtonFragment = gql`
    fragment ApplyButton_post on PostType {
        id
        uuid
        applyLink
        matchesGlobalPreferences
    }
`

interface ApplyButtonProps {
    post: ApplyButton_post
    listing?: ListingInfo_listing
}

const ApplyButton = (props: ApplyButtonProps) => {
    const trackApply = () => {
        mixpanel.track(TRACK_EVENTS.BUTTON_CLICKED, {
            type: BUTTON_TYPES.APPLY,
            post_uuid: props.post.uuid,
            listing_uuid: props.listing?.uuid,
            applylist_id: props.listing?.applylist.id,
            applylist_slug: props.listing?.applylist.slug,
            apply_link: props.post.applyLink,
            matches_preferences: props.post.matchesGlobalPreferences,
        })
    }

    return (
        <LinkButton
            href={props.post.applyLink}
            target="_blank"
            onClick={trackApply}
            size="small"
        >
            Apply
        </LinkButton>
    )
}

ApplyButton.fragment = ApplyButtonFragment

export default ApplyButton
